module.exports = __webpack_public_path__ + "media/icons/logo-mark2-4add5b1f.svg";